export default {"src":"/_next/static/media/dual_materiality_assessment_for_holistic_strategy.53e20e6c.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};